import type { Locale } from '@seek/melways-sites';
import { selectLanguage } from '../appConfig/appConfig';
import { selectCountry } from '../location/location';
import type { ChaliceStore } from '../reducer';

export {
  selectCandidateOnboardingBanner,
  selectLanguage,
  selectPrivacyPolicyBanner,
  selectSite,
  selectZone,
  selectZoneFeatures,
  setLanguage,
  setSite,
  setZone,
  setZoneFeatures,
} from '../appConfig/appConfig';
export { selectFeatureFlag } from '../featureFlags/featureFlags';
export {
  selectIsJobDetailsPending,
  selectJobDetailsPersonalised,
  selectJobDetailsResult,
  selectJobDetailsViewedCorrelationId,
  selectPageLoadedCount,
} from '../jobdetails/jobdetails';
export { selectLmis } from '../lmis/lmis';
export {
  selectCountry,
  selectHash,
  selectHostname,
  selectIsHomePage,
  selectIsJDP,
  selectIsJDPSplitView,
  selectIsSrp,
  selectLocation,
  selectLocationPageNumber,
  selectPageNumber,
  selectPageTitle,
  selectPathname,
  selectPrevPathname,
  selectProtocol,
  selectQuery,
  selectUrl,
} from '../location/location';
export { canShowNudges, selectNudges } from '../nudges/nudges';
export { selectRecentSearches } from '../recentSearches/recentSearches';
export {
  selectCanonicalCompany,
  selectCompanySuggestion,
  selectIsCompanySearch,
  selectIsRadialFilterNudgeShown,
  selectIsRadialFilterShown,
  selectIsResultsHidden,
  selectIsResultsInError,
  selectIsResultsLoading,
  selectIsZeroResult,
  selectJoraCrossLink,
  selectNormalisedCompanyName,
  selectPaginationParameters,
  selectPaginationTotalPages,
  selectRelatedSearches,
  selectResults,
  selectResultsCount,
  selectResultsJobIds,
  selectResultsLocation,
  selectResultsLocationDescription,
  selectResultsLocationDescriptions,
  selectResultsSortMode,
  selectResultsTitle,
  selectSearchParams,
  selectSelectedJobId,
  selectSolMetadata,
  selectSolMetadataString,
  selectUniqueSearchToken,
} from '../results/results';
export {
  selectSaveSearchEmailAddress,
  selectSaveSearchErrorMessage,
  selectSaveSearchStatus,
  selectSaveable,
} from '../saveSearch/saveSearch';
export {
  selectClearCompanyRefinements,
  selectIsFiltersExpanded,
  selectKeywordField,
  selectSearchQuery,
  selectWhereField,
  selectRefinement,
} from '../search/search';
export { selectCanonicalUrl, selectAlternateLinks } from '../seo/seo';
export { selectIsPageLoaded } from '../ui/ui';
export {
  selectAuthenticated,
  selectEmailAddress,
  selectEventCaptureTestTags,
  selectFirstName,
  selectIsAuthenticationResolved,
  selectLoginId,
  selectSeekerId,
  selectSessionId,
  selectUserClientId,
  selectUserTestHeaders,
} from '../user/user';
export { selectBanner } from '../banner/banner';

// helper function to get selected Locale without hooks
export const selectSelectedLocaleFromCountryAndLanguage = (
  state: ChaliceStore,
) => `${selectLanguage(state)}-${selectCountry(state)}` as Locale;
